import * as React from 'react';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { MdAttachFile } from 'react-icons/md';
import { ComponentProps } from 'ui/common';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ChildEntityCountShape } from 'app/area/case/selectors';

interface FactItemAttachedFilesProps extends ComponentProps, FactItemProps {
  numberOfFiles: ChildEntityCountShape;
  numberOfLinks: ChildEntityCountShape;
}

export const AttachedFilesFactItem = (props: FactItemAttachedFilesProps) => {
  const { tooltip, title, numberOfFiles, url, numberOfLinks, linkDomain, portalTarget } = props;
  const iconAttachments = <MdAttachFile />;
  const numberOfAttachments = (numberOfFiles?.count || 0) + (numberOfLinks?.count  || 0) ;
  const items = [
    { value: numberOfAttachments, tooltip }
  ];

  if (!numberOfAttachments) {
    return null;
  }
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url}>
    <BadgeList
      icon={iconAttachments}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
